export const priceValidationCodes = {
  invalidFormatError: 1,
  emptyFileldError: 2,
  newDirection: 3,
  earlierDate: 4,
  codeListChanged: 5,
  laterDate: 6,
  noChangePriceChanged: 7,
  priceIncreased: 8,
  priceDecreased: 9,
  decreasePriceIncreased: 10,
  increasePriceDecreased: 11,
  changePriceNotChanged: 12,
  tarificationRulesChanged: 13,
  countryNotDefined: 14,
} as const;
